/** Avoid running the same function twice within the specified timeframe. */
export const debounce = (func: Function, wait: number) => {
    // eslint-disable-next-line
    let timeout: any;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.call(this, ...args), wait);
    };
};
